export default __webpack_public_path__ + "static/media/thor-node-silver.810d97e8.svg";